import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AsyncSelect from 'react-select-v3/async';
import * as http from 'utils/http';
import config from 'config';
import { injectIntl } from 'react-intl';

import debouncePromise from 'debounce-promise';

import { reactSelectStyles, StyledFilter } from './styled';
import { Checkbox } from '@ontruck/orc';
import serialize from 'utils/serialize';

class ShipperFilter extends Component {
  static filterName = 'ShipperFilter';

  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
    intl: PropTypes.any,
    clearable: PropTypes.bool,
    disabled: PropTypes.bool,
    invalid: PropTypes.bool,
    showHiddenOption: PropTypes.bool,
    stylingProps: PropTypes.object.isRequired,
  };

  static defaultPropTypes = {
    clearable: true,
    disabled: false,
    showHiddenOption: false,
    invalid: false,
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.getShippers = debouncePromise(getShippers, 500, { leading: true });
    this.state = { showAll: false };
  }

  handleChange(value) {
    if (!this.props.onChange) {
      return;
    }
    const { onChange } = this.props;
    onChange(value);
  }

  formatLabel(value) {
    if (!!value && !!value.id) {
      return {
        id: value.id,
        label: !!value.label ? value.label : `Shipper ID: ${value.id}`,
      };
    }
    return value;
  }

  handleShowHiddenChange(showAll) {
    this.setState({ showAll });
  }

  render() {
    const {
      selectProps = {},
      intl,
      value,
      disabled,
      invalid,
      stylingProps,
      showHiddenOption,
    } = this.props;

    const t = intl.messages.components.ShipmentFilters;
    const formattedValue = this.formatLabel(value);

    return (
      <StyledFilter
        {...stylingProps}
        showHiddenOption={showHiddenOption}
        data-testid="shipper-filter"
      >
        {/* 
        to translate the "No options message" in the shippers seach we have to do some work
        https://react-select.com/components#replaceable-components
        */}
        <AsyncSelect
          isClearable
          disabled={disabled}
          invalid={invalid}
          placeholder={t.shipper_filter_placeholder}
          value={formattedValue}
          filterOptions={false}
          onChange={this.handleChange}
          loadOptions={(input) => this.getShippers(input, this.state.showAll)}
          styles={reactSelectStyles}
          {...selectProps}
        />
        {showHiddenOption && (
          <Checkbox
            label={t.shipper_filter_show_hidden}
            checked={this.state.showAll}
            onChange={(_, { value: v }) => this.handleShowHiddenChange(v)}
          />
        )}
      </StyledFilter>
    );
  }
}

export async function getShippers(input, showAll) {
  if (!input || input.length < 3) {
    return Promise.resolve([{}]);
  }

  const params = serialize({
    search: input,
    page_size: 0,
    ordering: 'company_name',
    show_all: showAll || undefined,
  });
  const shippers = await http.get(`${config.API_URL}mercury/shippers/?${params}`);

  if (shippers.length > 0) return formatOptions(shippers);

  const shippersWithUserEmails = await http.get(
    `${config.API_URL}mercury/shippers/?user_email=${input}&page_size=0`
  );

  return formatOptions(shippersWithUserEmails);
}

export function formatOptions(listOfShippers) {
  return (listOfShippers || []).map(({ url, company_name, id }) => ({
    label: company_name,
    value: url,
    id,
  }));
}

export default injectIntl(ShipperFilter);
